export function parseJwt<
  T extends Record<string, unknown> = Record<string, unknown>,
>(token: string): T | null {
  try {
    const base64Url = token.split('.')[1]
    if (!base64Url) throw new Error('Invalid JWT format')

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join(''),
    )

    return JSON.parse(jsonPayload) as T
  } catch (e) {
    console.error('Invalid JWT:', e)
    return null
  }
}

export const isValidToken = (token: string): boolean => {
  const payload = parseJwt<{ exp: number }>(token)
  if (!payload || typeof payload.exp !== 'number') return false

  const currentTime = Math.floor(Date.now() / 1000) // current time in seconds
  return payload.exp > currentTime
}
